import { makeStyles } from '@mui/styles';

export 
const useStyles = makeStyles({
  table: {
    minWidth: 700,
    '& .MuiTableCell-root': {
      '& .MuiInputBase-root ': { marginTop: '0', marginBottom: '0' },
      '& .MuiFormControl-root': { marginTop: '0', marginBottom: '0' },
    },
  },
  addBusinessWrapper: {
    display: 'flex',
  },
  autocompleteWrapper: {
    width: '432px',
  },
});
